module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00080.e6d4889.png";